import script from "./PipPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./PipPlayer.vue?vue&type=script&setup=true&lang=js"

import "./PipPlayer.vue?vue&type=style&index=0&id=01c19bfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c19bfa"]])

export default __exports__